// @flow
import {
	FETCH_ORDERS,
	FETCH_ORDERS_SUCCESS,
	FETCH_ORDERS_ERROR,
	SELECT_ORDER,
	FETCH_LAST_ORDER,
	FETCH_LAST_ORDER_SUCCESS,
	FETCH_LAST_ORDER_ERROR,
	FETCH_ORDER_INVOICE,
	FETCH_ORDER_INVOICE_ERROR,
	FETCH_ORDER_INVOICE_SUCCESS,
	SET_PENDING_ORDERS,
	SYNC_PENDING_ORDERS,
	CANCEL_SYNC_PENDING_ORDERS,
	CANCEL_PENDING_ORDER,
	CANCEL_PENDING_ORDER_SUCCESS,
	CANCEL_PENDING_ORDER_ERROR,
	POOL_ACTIVE_ORDER,
	CANCEL_POOL_ACTIVE_ORDER,
	CANCEL_VS_ORDER,
	POOL_ALL_LIVE_ORDERS,
	CANCEL_POOL_ALL_LIVE_ORDERS,
	SET_ALL_LIVE_ORDERS,
	UPDATE_ORDER_STATUS_REALTIME,
	SET_SOCKET_CONNECTION,
	ADD_REALTIME_STATUS,
	CLEAR_REALTIME_STATUSES,
	ADD_MACHINE_MESSAGE,
} from './types';
import type { Action } from './types';

export const fetchOrders = (mobile: string): Action => ({
	type: FETCH_ORDERS,
	payload: { mobile },
});

export const fetchOrdersSuccess = (orders: Array<any>): Action => ({
	type: FETCH_ORDERS_SUCCESS,
	payload: orders,
});

export const fetchOrdersError = (error: Error): Action => ({
	type: FETCH_ORDERS_ERROR,
	payload: error,
});

export const selectOrder = (order: any): Action => ({
	type: SELECT_ORDER,
	payload: order,
});

export const fetchLastOrder = (mobile: string): Action => ({
	type: FETCH_LAST_ORDER,
	payload: mobile,
});

export const fetchLastOrderSuccess = (lastOrder: {}): Action => ({
	type: FETCH_LAST_ORDER_SUCCESS,
	payload: lastOrder,
});

export const fetchLastOrderError = (error: Error): Action => ({
	type: FETCH_LAST_ORDER_ERROR,
	payload: error,
});

export const fetchOrderInvoice = (orderId: string, type: string): Action => ({
	type: FETCH_ORDER_INVOICE,
	payload: { orderId, type },
});

export const fetchOrderInvoiceSuccess = (orderInvoice: {} | null): Action => ({
	type: FETCH_ORDER_INVOICE_SUCCESS,
	payload: orderInvoice,
});

export const fetchOrderInvoiceError = (error: Error): Action => ({
	type: FETCH_ORDER_INVOICE_ERROR,
	payload: error,
});

export const setPendingOrders = (pendingOrders: Array<{}> | {}): Action => ({
	type: SET_PENDING_ORDERS,
	payload: pendingOrders,
});

export const syncPendingOrders = (mobile: string, delay?: number): Action => ({
	type: SYNC_PENDING_ORDERS,
	payload: { mobile, delay },
});

export const cancelSyncPendingOrders = (): Action => ({
	type: CANCEL_SYNC_PENDING_ORDERS,
});

export const cancelPendingOrder = (orderId: string, updateCart: boolean = false): Action => ({
	type: CANCEL_PENDING_ORDER,
	payload: {
		orderId,
		updateCart,
	},
});

export const cancelPendingOrderSuccess = (orderId?: string): Action => ({
	type: CANCEL_PENDING_ORDER_SUCCESS,
	payload: { orderId },
});

export const cancelPendingOrderError = (orderId?: string): Action => ({
	type: CANCEL_PENDING_ORDER_ERROR,
	payload: { orderId },
});

export const poolActiveOrder = (orderId: string): Action => ({
	type: POOL_ACTIVE_ORDER,
	payload: { orderId },
});
  
export const cancelPoolingActiveOrder = (): Action => ({
	type: CANCEL_POOL_ACTIVE_ORDER,
});

export const cancelVirtualOrder = (orderId: string): Action => ({
	type: CANCEL_VS_ORDER,
	payload: { orderId },
});

export const poolAllLiveOrders = (orders: Array<{[key: string]: any}>): Action => ({
	type: POOL_ALL_LIVE_ORDERS,
	payload: orders,
});
  
export const cancelPoolAllLiveOrders = (): Action => ({
	type: CANCEL_POOL_ALL_LIVE_ORDERS,
});


export const setAllLiveOrders = (liveOrders: Array<{[key:string]: any}> | null): Action => ({
	type: SET_ALL_LIVE_ORDERS,
	payload: liveOrders,
});

// Real-time WebSocket action creators
export const updateOrderStatusRealtime = (statusUpdate: {
	orderId: string,
	status: string,
	timestamp: string,
	metadata: any,
	machineId: string
}): Action => ({
	type: UPDATE_ORDER_STATUS_REALTIME,
	payload: statusUpdate,
});

export const setSocketConnection = (connected: boolean): Action => ({
	type: SET_SOCKET_CONNECTION,
	payload: connected,
});

export const addRealtimeStatus = (statusUpdate: any): Action => ({
	type: ADD_REALTIME_STATUS,
	payload: statusUpdate,
});

export const clearRealtimeStatuses = (): Action => ({
	type: CLEAR_REALTIME_STATUSES,
});

export const addMachineMessage = (machineMessage: {
	id: string,
	imei: string,
	messageType: string,
	timestamp: string,
	priority: string,
	display: {
		header: string,
		subHeader: string,
		showOnUI: boolean,
		autoDismiss: boolean,
		dismissAfter: number
	},
	metadata: any
}): Action => ({
	type: ADD_MACHINE_MESSAGE,
	payload: machineMessage,
});